export function fmtDuration(s: number | null | undefined): string {
  if (s === null || s === undefined || !Number.isFinite(s)) return '—';
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = Math.floor(s % 60);
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}` : `${m}:${String(sec).padStart(2, '0')}`;
}
export const fmtTime = (ts: number, tz?: string) => new Date(ts * 1000).toLocaleTimeString('en-GB', { hour12: false, timeZone: tz });
export const fmtDate = (ts: number, tz?: string) => { const d = new Date(ts * 1000); const p = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d); return p; };
export const fmtDateTime = (ts: number) => `${fmtDate(ts)} ${fmtTime(ts)}`;

export type Tone = 'good' | 'fair' | 'poor' | 'none';
export const scoreTone = (s: number | null | undefined): Tone => (s === null || s === undefined ? 'none' : s >= 85 ? 'good' : s >= 60 ? 'fair' : 'poor');
export const toneClass: Record<Tone, string> = { good: 'text-lime', fair: 'text-amber', poor: 'text-rose', none: 'text-dim' };
export const toneBg: Record<Tone, string> = { good: 'bg-lime/15 text-lime', fair: 'bg-amber/15 text-amber', poor: 'bg-rose/15 text-rose', none: 'bg-line text-dim' };
export const fmtScore = (s: number | null | undefined) => (s === null || s === undefined ? '—' : String(Math.round(s)));

export function fmtMetricRaw(v: number, unit: string): string {
  switch (unit) {
    case 'nm': return `${v.toFixed(2)} nm`;
    case 'ft': case 'm': return `${Math.round(v)} ${unit}`;
    case 'kt': return `${v.toFixed(1)} kt`;
    case 'deg': return `${v.toFixed(1)}°`;
    case 'share': return `${Math.round(v * 100)}%`;
    default: return `${v} ${unit}`;
  }
}
export const METRIC_LABELS: Record<string, string> = {
  downwindDistance: 'Downwind distance', altitudeHold: 'Altitude hold', legSquareness: 'Leg squareness', finalOvershoot: 'Final overshoot', finalRollout: 'Final rollout', speedConsistency: 'Speed consistency',
  glidepath: 'Glidepath', descentRate: 'Descent rate', speedStability: 'Speed stability', centreline: 'Centreline', touchdown: 'Touchdown point',
};
export const EVENT_LABELS: Record<string, string> = { takeoff: 'Takeoff', touch_and_go: 'Touch & go', stop_and_go: 'Stop & go', full_stop: 'Full stop', low_approach: 'Low approach', go_around: 'Go-around' };
